import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState, updateArrayState } from "../utils";
import log from "../../utils/log";

const useUserStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      /**
       * Updates the cache of users in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {string} query - query URL. eg: ?pagination=1
       * @param {Array} param - An array containing the user object(s) to be added, updated, or deleted.
       */
      updateUsersCache: (action, query, param) => {
        set({ usersCache: updateObjectState(get().usersCache, action, { [query]: param }) });
      },
      /**
       * Updates the cache of a single user in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {Array} param - An array containing the user object(s) to be added, updated, or deleted.
       */
      updateSingleUserCache: (action, param) => {
        set({ singleUserCache: updateArrayState(get().singleUserCache, action, param) });
      },
      resetUser: () => set(initialState), // Reset function
      //getter
      getUsers: (query) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return [obj] if has cache of provided query
        return get().usersCache[query];
      },
      getSingleUser: (id) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return obj if has cache of provided id
        if (!id) {
          return undefined;
        }
        return get().singleUserCache.find((e) => e.id === id);
      },
    })),
    {
      name: "pearl-user", //name of store, must be unique
      storage: createJSONStorage(() => sessionStorage), // Use session storage
    }
  )
);

export default useUserStore;
